module.exports = __webpack_public_path__ + "img/logo-shiba888.7c94a292.png";